// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__Qpyiz","header":"MergedInvoice_header__2EdFo"};